import { gql } from "@apollo/client";

export const FETCH_MODEL_INSIGHTS_MODEL_METADATA = gql`
  query FetchModelInsightsModelMetadata($cycleId: String!) {
    me {
      mmm {
        modelInsightsModelMetadata(cycleId: $cycleId) {
          hdi_prob
          indicator_data_columns {
            is_ready_for_use_in_model
            column_name
            is_present
            is_from_mta
            is_from_mmm_custom_data
            is_spend
            is_target
            is_calendar_of_events
            mta_breakdowns {
              key
              value
            }
            friendly_name
            column_type
            target_typical_value
            target_price_value_per_unit_target
            dataset_most_recent_non_blank_date
            approval_status
            operator_notes
          }
          kpi_formulas {
            kpi_name
            equation
            friendly_name
            is_active
            is_default_kpi
            kpi_type
          }
          model_metrics
          model_run_date
          out_of_sample_cutoff_date
          period_length_days
          promo_data_columns {
            is_ready_for_use_in_model
            column_name
            is_present
            is_from_mta
            is_from_mmm_custom_data
            is_spend
            is_target
            is_calendar_of_events
            mta_breakdowns {
              key
              value
            }
            friendly_name
            column_type
            target_typical_value
            target_price_value_per_unit_target
            dataset_most_recent_non_blank_date
            approval_status
            operator_notes
          }
          spend_data_columns {
            is_ready_for_use_in_model
            column_name
            is_present
            is_from_mta
            is_from_mmm_custom_data
            is_spend
            is_target
            is_calendar_of_events
            mta_breakdowns {
              key
              value
            }
            friendly_name
            column_type
            target_typical_value
            target_price_value_per_unit_target
            dataset_most_recent_non_blank_date
            approval_status
            operator_notes
          }
          start_day_of_week
          target_data_columns {
            is_ready_for_use_in_model
            column_name
            is_present
            is_from_mta
            is_from_mmm_custom_data
            is_spend
            is_target
            is_calendar_of_events
            mta_breakdowns {
              key
              value
            }
            friendly_name
            column_type
            target_typical_value
            target_price_value_per_unit_target
            dataset_most_recent_non_blank_date
            approval_status
            operator_notes
          }
          training_end_date
          training_start_date
          coe {
            description
            campaign_type
            start_date
            end_date
          }
        }
      }
    }
  }
`;

export const FETCH_MODEL_INSIGHTS_MODEL_FIT = gql`
  query FetchModelInsightsModelFit($cycleId: String!) {
    me {
      mmm {
        modelInsightsModelFit(cycleId: $cycleId)
      }
    }
  }
`;

export const FETCH_MODEL_INSIGHTS = gql`
  query FetchModelInsights($cycleId: String!) {
    me {
      mmm {
        modelInsightsCostCurves(cycleId: $cycleId)
        modelInsightsCostCurvesByQuantile(cycleId: $cycleId)
        modelInsightsHistoricalContributions(cycleId: $cycleId)
      }
    }
  }
`;
